import React, { Component } from "react";
import './slideshow.css';
import Slider from "react-slick";
import { FormattedMessage } from 'react-intl';

const settings = {
  dots: true,
  infinite: true,
  arrows: false,
  speed: 2500,
  fade: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 5000,
  pauseOnHover: false
};

class Slideshow extends Component {

  render() {
    return (
      <div className="slide-main">
        <img className="slide-swirl" src="img/slides/swirl-1.png" alt="Swirl" />
        <span className="slide-text" ><FormattedMessage id={'slide.create'} /></span>
        <Slider className="front-page-slider" {...settings}>
          <div>
            <div className="slide-image slide-image1" />
          </div>
          <div>
            <div className="slide-image slide-image2 slide-image-mob-long" />
          </div>
          <div>
            <div className="slide-image slide-image3 slide-image-mob-long" />
          </div>
        </Slider>
      </div>
    );
  }
}

export default Slideshow;



// WEBPACK FOOTER //
// ./src/slideshow/slideshow.js